/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProcessResponse } from '../../models/process-response';

export interface TriggerConfig$Params {
  configId: string;
}

export function triggerConfig(http: HttpClient, rootUrl: string, params: TriggerConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessResponse>> {
  const rb = new RequestBuilder(rootUrl, triggerConfig.PATH, 'post');
  if (params) {
    rb.path('configId', params.configId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProcessResponse>;
    })
  );
}

triggerConfig.PATH = '/config/{configId}/trigger';
